import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16" {...props}>
    <path
      fill="none"
      stroke="#17181A"
      d="m9.693 2.403-7.605 7.724A3.148 3.148 0 0 0 2 14.452a2.902 2.902 0 0 0 4.153.15l9.793-9.345a2.436 2.436 0 0 0 .032-3.494 2.484 2.484 0 0 0-3.529.035L5.031 9.434a1.531 1.531 0 0 0-.004 2.13 1.47 1.47 0 0 0 2.086.03l5.915-5.79"
    />
  </svg>
);
const Memo = memo(SvgAttachment);
export default Memo;
